import apiClient from './apiClient';

export interface F932 {
  f932_01: string; f932_11: string; f932_12: string; f932_13: boolean;
  f932_14: number; f932_18: string; f932_21: string | null; f932_22: string | null;
  f932_91: string; f932_92: string | null; f932_93: string;
}
export interface ListResponse { data: F932[]; total: number; page: number; size: number; }

export const payItemApi = {
  async list(page = 1, size = 50, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    return (await apiClient.get('/api/pay-item', { params })).data;
  },
  async get(code: string): Promise<F932> {
    return (await apiClient.get(`/api/pay-item/${encodeURIComponent(code)}`)).data;
  },
  async create(data: { f932_01: string; f932_11: string; f932_12: string; f932_13: boolean; f932_14: number; f932_18: string; f932_21?: string | null; f932_22?: string | null }): Promise<F932> {
    return (await apiClient.post('/api/pay-item', data)).data;
  },
  async update(code: string, data: { f932_11: string; f932_12: string; f932_13: boolean; f932_14: number; f932_18: string; f932_21?: string | null; f932_22?: string | null }): Promise<F932> {
    return (await apiClient.put(`/api/pay-item/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/pay-item/${encodeURIComponent(code)}`);
  },
};
